<button
  class="custom-button"
  [class.flat]="variant === 'flat'"
  [class.stroked]="variant === 'stroked'"
  [class.close]="variant === 'close'"
  [class.icon]="variant === 'icon'"
  [class.default]="variant === 'default'"
  [class.link]="variant === 'link'"
  [class.disabled]="disabled || loading"
  [class.secondary]="variant === 'secondary'"
  [style.width]="width"
  [style.height]="height"
  [type]="type"
  [ngClass]="{
  'primary': color === 'primary',
  'warn': color === 'warn',
}"
  matRipple
  [matRippleDisabled]="disabled || loading"
  (click)="onClick($event)"
>
<!-- [matTooltip]="tooltip" -->
  <ng-container *ngIf="loading; else normalContent">
    <mat-spinner diameter="20" color="accent"></mat-spinner>
  </ng-container>
  
  <ng-template #normalContent>
    <mat-icon *ngIf="iconName">{{ iconName }}</mat-icon>
    <span class="button-content" *ngIf="label">{{ label }}</span>
    <ng-content></ng-content>
  </ng-template>
</button>
